var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_10721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.875 3C7.875 1.96447 7.03553 1.125 6 1.125C4.96447 1.125 4.125 1.96447 4.125 3V6C4.125 7.03553 4.96447 7.875 6 7.875C7.03553 7.875 7.875 7.03553 7.875 6V3Z",
    stroke: "#454551",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9.375V11.25",
    stroke: "#454551",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6C9.375 6.89511 9.01942 7.75355 8.38649 8.38649C7.75355 9.01942 6.89511 9.375 6 9.375C5.10489 9.375 4.24645 9.01942 3.61351 8.38649C2.98058 7.75355 2.625 6.89511 2.625 6",
    stroke: "#454551",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_10721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOutline);
export default __webpack_public_path__ + "static/media/mic-outline.19185c5b30b689775ea5c78a13a41340.svg";
export { ForwardRef as ReactComponent };